import { useEffect, useRef, useState } from 'react';
import { cropPosition, detectFocus } from '../lib/faceFocus';
export default function SmartLeadImage({ story, loading = 'lazy', ratio = 16 / 9 }) {
  const ref = useRef(null);
  const [crop, setCrop] = useState({src:story.img, position:'50% 8%', fit:'cover'});
  useEffect(() => {
    let active = true;
    const image = ref.current;
    const update = async () => {
      if (!image?.naturalWidth) return;
      const manual = story.focalPoint;
      const focal = manual || await detectFocus(story.img).catch(() => null);
      if (!active || !focal) return;
      const w = image.naturalWidth, h = image.naturalHeight;
      const visibleW = Math.min(w, h * ratio), visibleH = Math.min(h, w / ratio);
      // Preserve all detected faces when they cannot fit together in a wide crop.
      const fit = focal.faceWidth * w > visibleW * 0.9 || focal.faceHeight * h > visibleH * 0.9 ? 'contain' : 'cover';
      setCrop({src:story.img, position:cropPosition(w,h,focal,ratio), fit});
    };
    const observer = new IntersectionObserver(entries => { if (entries.some(e => e.isIntersecting)) { observer.disconnect(); if (image.complete) update(); else image.addEventListener('load', update, {once:true}); } }, {rootMargin:'150px'});
    if (image) observer.observe(image);
    return () => { active = false; observer.disconnect(); image?.removeEventListener('load',update); };
  }, [story.img, story.focalPoint, ratio]);
  return <img ref={ref} src={story.img} alt={story.imgAlt || story.title} loading={loading} className="w-full h-full" style={{objectFit:crop.src === story.img ? crop.fit : 'cover', objectPosition:crop.src === story.img ? crop.position : '50% 8%'}} />;
}
